import type { UserData, AuthConfig } from '../types/types'
import { AccessTokenData, IdTokenData } from '../types/tokenTypes'
import cookieHandler from '../handlers/cookieHandler'
import tokenHandler from '../handlers/tokenHandler'

export default (config: AuthConfig, cookieHeader?: string) => {
  const token = tokenHandler(config)
  const cookies = cookieHandler(cookieHeader)

  return (): UserData | null => {
    const idToken = token.getValidToken<IdTokenData>(cookies.getIdToken())
    const accessToken = token.getValidToken<AccessTokenData>(cookies.getAccessToken())

    if (!idToken || !accessToken) return null

    return token.getUserData(idToken, accessToken)
  }
}
